import cls from 'classnames';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';

import SidebarLogin from '../../SidebarLogin';
import Header from '../Header';
import Menu from '../Menu';

import useStyles from './styles';
import { IMobileNavigation } from './types';

function MobileNavigation({ isVisible, handleToggleMenu, selectedCategory }: IMobileNavigation) {
  const classes = useStyles();

  return (
    <div
      onClick={handleToggleMenu}
      className={cls(classes.backdrop, {
        isVisible,
      })}
    >
      <nav className={classes.menuContainer} onClick={(e) => e.stopPropagation()}>
        <Header
          icon={IconCrossLarge}
          handleToggleMenu={handleToggleMenu}
          category={selectedCategory}
          hasLogin={false}
        />
        <Menu />
        {isVisible && <SidebarLogin />}
      </nav>
    </div>
  );
}
export default MobileNavigation;
